module.exports = __webpack_public_path__ + "assets/img/hero_4.854dcaf8.png";